/* tslint:disable */
import {
  UserProfile,
  CompanyAccount,
  PropertyUnits,
  IncomeInvoice,
  WorkOrderExpenses,
  PropertyBills
} from '../index';

declare var Object: any;
export interface WorkOrderInterface {
  "subject": string;
  "category"?: string;
  "invoice_no"?: string;
  "work_description": string;
  "vendor_notes": string;
  "status": string;
  "due_date": Date;
  "complete_date"?: Date;
  "priority": string;
  "billed_to"?: string;
  "is_billed"?: boolean;
  "id"?: number;
  "vendor_id"?: number;
  "assigned_user_id"?: number;
  "property_id"?: number;
  "property_unit_id"?: number;
  "incomeInvoiceId"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "propertyBillsId"?: number;
  vendor?: UserProfile;
  assigned_user?: UserProfile;
  property?: CompanyAccount;
  property_unit?: PropertyUnits;
  incomeInvoices?: IncomeInvoice;
  incomeInvoice?: IncomeInvoice;
  workOrderExpenses?: WorkOrderExpenses[];
  propertyBills?: PropertyBills;
}

export class WorkOrder implements WorkOrderInterface {
  "subject": string;
  "category": string;
  "invoice_no": string;
  "work_description": string;
  "vendor_notes": string;
  "status": string;
  "due_date": Date;
  "complete_date": Date;
  "priority": string;
  "billed_to": string;
  "is_billed": boolean;
  "id": number;
  "vendor_id": number;
  "assigned_user_id": number;
  "property_id": number;
  "property_unit_id": number;
  "incomeInvoiceId": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "propertyBillsId": number;
  vendor: UserProfile;
  assigned_user: UserProfile;
  property: CompanyAccount;
  property_unit: PropertyUnits;
  incomeInvoices: IncomeInvoice;
  incomeInvoice: IncomeInvoice;
  workOrderExpenses: WorkOrderExpenses[];
  propertyBills: PropertyBills;
  constructor(data?: WorkOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WorkOrder`.
   */
  public static getModelName() {
    return "WorkOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WorkOrder for dynamic purposes.
  **/
  public static factory(data: WorkOrderInterface): WorkOrder{
    return new WorkOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WorkOrder',
      plural: 'WorkOrders',
      path: 'WorkOrders',
      idName: 'id',
      properties: {
        "subject": {
          name: 'subject',
          type: 'string'
        },
        "category": {
          name: 'category',
          type: 'string'
        },
        "invoice_no": {
          name: 'invoice_no',
          type: 'string'
        },
        "work_description": {
          name: 'work_description',
          type: 'string'
        },
        "vendor_notes": {
          name: 'vendor_notes',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "due_date": {
          name: 'due_date',
          type: 'Date'
        },
        "complete_date": {
          name: 'complete_date',
          type: 'Date'
        },
        "priority": {
          name: 'priority',
          type: 'string'
        },
        "billed_to": {
          name: 'billed_to',
          type: 'string'
        },
        "is_billed": {
          name: 'is_billed',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "vendor_id": {
          name: 'vendor_id',
          type: 'number'
        },
        "assigned_user_id": {
          name: 'assigned_user_id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "incomeInvoiceId": {
          name: 'incomeInvoiceId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "propertyBillsId": {
          name: 'propertyBillsId',
          type: 'number'
        },
      },
      relations: {
        vendor: {
          name: 'vendor',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'vendor_id',
          keyTo: 'id'
        },
        assigned_user: {
          name: 'assigned_user',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'assigned_user_id',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        property_unit: {
          name: 'property_unit',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        incomeInvoices: {
          name: 'incomeInvoices',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'work_order_id'
        },
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'belongsTo',
                  keyFrom: 'incomeInvoiceId',
          keyTo: 'id'
        },
        workOrderExpenses: {
          name: 'workOrderExpenses',
          type: 'WorkOrderExpenses[]',
          model: 'WorkOrderExpenses',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'work_order_id'
        },
        propertyBills: {
          name: 'propertyBills',
          type: 'PropertyBills',
          model: 'PropertyBills',
          relationType: 'belongsTo',
                  keyFrom: 'propertyBillsId',
          keyTo: 'id'
        },
      }
    }
  }
}
